module.exports = __webpack_public_path__ + "r-v3/img/ico_repeat_01_white.55172a63.svg";